var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoOutlined(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_11564_42757",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 25
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_11564_42757)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 17.5C12.2833 17.5 12.5292 17.3958 12.7375 17.1875C12.9458 16.9792 13.05 16.7362 13.05 16.4587V12.5163C13.05 12.2388 12.9458 12 12.7375 11.8C12.5292 11.6 12.2833 11.5 12 11.5C11.7167 11.5 11.4708 11.6042 11.2625 11.8125C11.0542 12.0208 10.95 12.2638 10.95 12.5413V16.4837C10.95 16.7612 11.0542 17 11.2625 17.2C11.4708 17.4 11.7167 17.5 12 17.5ZM12 9.475C12.2833 9.475 12.5292 9.37083 12.7375 9.1625C12.9458 8.95417 13.05 8.70833 13.05 8.425C13.05 8.14167 12.9458 7.89583 12.7375 7.6875C12.5292 7.47917 12.2833 7.375 12 7.375C11.7167 7.375 11.4708 7.47917 11.2625 7.6875C11.0542 7.89583 10.95 8.14167 10.95 8.425C10.95 8.70833 11.0542 8.95417 11.2625 9.1625C11.4708 9.37083 11.7167 9.475 12 9.475ZM12 22.5C10.6167 22.5 9.31667 22.2375 8.1 21.7125C6.88333 21.1875 5.825 20.475 4.925 19.575C4.025 18.675 3.3125 17.6167 2.7875 16.4C2.2625 15.1833 2 13.8833 2 12.5C2 11.1167 2.2625 9.81667 2.7875 8.6C3.3125 7.38333 4.025 6.325 4.925 5.425C5.825 4.525 6.88333 3.8125 8.1 3.2875C9.31667 2.7625 10.6167 2.5 12 2.5C13.3833 2.5 14.6833 2.7625 15.9 3.2875C17.1167 3.8125 18.175 4.525 19.075 5.425C19.975 6.325 20.6875 7.38333 21.2125 8.6C21.7375 9.81667 22 11.1167 22 12.5C22 13.8833 21.7375 15.1833 21.2125 16.4C20.6875 17.6167 19.975 18.675 19.075 19.575C18.175 20.475 17.1167 21.1875 15.9 21.7125C14.6833 22.2375 13.3833 22.5 12 22.5ZM11.9941 20.4C14.1814 20.4 16.0458 19.6312 17.5875 18.0935C19.1292 16.5558 19.9 14.6933 19.9 12.5059C19.9 10.3186 19.1312 8.45417 17.5935 6.9125C16.0558 5.37083 14.1933 4.6 12.006 4.6C9.81865 4.6 7.95417 5.36885 6.4125 6.90655C4.87083 8.44423 4.1 10.3067 4.1 12.4941C4.1 14.6814 4.86885 16.5458 6.40655 18.0875C7.94423 19.6292 9.80673 20.4 11.9941 20.4Z",
    fill: "#1F6CF9"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoOutlined);
export default __webpack_public_path__ + "static/media/info_outlined.749ccb53beb516ed9b18a532b8c20149.svg";
export { ForwardRef as ReactComponent };